import { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import EmojiIcon from '@mui/icons-material/InsertEmoticon'
import Picker from '@emoji-mart/react'
import styles from './EmojiPicker.pcss'

const data = require('@emoji-mart/data/sets/14/facebook.json')

interface EmojiPickerProps {
  className?: string
  inline?: boolean
  onSelect: (emoji: any) => void
}

export function EmojiPicker(props: EmojiPickerProps) {
  const { inline, className, onSelect } = props
  const [active, setActive] = useState(false)

  const toggleActive = () => {
    setActive(!active)
  }

  const content = (
    <div className={styles.picker} data-testid="emoji-picker-popup">
      <Picker theme="light" data={data} set="facebook" onEmojiSelect={onSelect} />
    </div>
  )

  return (
    <div className={`${styles.container} ${className || ''}`} data-testid="emoji-picker">
      {inline ? content : (
        <IconButton onClick={toggleActive} className={styles['btn-open']} size="large">
          <EmojiIcon fontSize="medium" className={styles['btn-icon']} />
        </IconButton>
      )}
      {active && (
        <ClickAwayListener onClickAway={toggleActive}>
          {content}
        </ClickAwayListener>
      )}
    </div>
  )
}

export function EmojiPickerInline({ className, onSelect }: EmojiPickerProps) {
  return (
    <div className={`${styles.picker} ${className || ''}`} data-testid="emoji-picker-popup">
      <Picker theme="light" data={data} set="facebook" onEmojiSelect={onSelect} />
    </div>
  )
}

export default EmojiPicker
